import { createSlice } from '@reduxjs/toolkit'

// Setup the initial state

const initialState = {
  consultInternalLists: {},
  consultInternationalLists: {},
  consultSafeWatchAlert: {},
  consultAlertNumber: {},
  insertClientOnListForReview: {},
  consultSpouseOnLists: {},
  consultRepresentativeOnLists: {},
};

export const listsSlice = createSlice({
  name: 'lists',
  initialState,
  reducers: {

    // Consult Internal Lists

    setConsultInternalListsLoading: (state) => {
      state.consultInternalLists = {
        isLoading: true,
      };
    },

    setConsultInternalListsSuccess: (state, action) => {
      state.consultInternalLists = {
        data: action.payload
      };
    },

    setConsultInternalListsFailure: (state, action) => {
      state.consultInternalLists = {
        error: action.payload,
      }
    },

    clearConsultInternalLists: (state) => {
      state.consultInternalLists = {}
    },

    // Consult International Lists

    setConsultInternationalListsLoading: (state) => {
      state.consultInternationalLists = {
        isLoading: true,
      };
    },

    setConsultInternationalListsSuccess: (state, action) => {
      state.consultInternationalLists = {
        data: action.payload
      };
    },

    setConsultInternationalListsFailure: (state, action) => {
      state.consultInternationalLists = {
        error: action.payload,
      }
    },

    clearConsultInternationalLists: (state) => {
      state.consultInternationalLists = {}
    },

    // Consult Safe Watch Alert

    setConsultSafeWatchAlertLoading: (state) => {
      state.consultSafeWatchAlert = {
        isLoading: true,
      };
    },

    setConsultSafeWatchAlertSuccess: (state, action) => {
      state.consultSafeWatchAlert = {
        data: action.payload
      };
    },

    setConsultSafeWatchAlertFailure: (state, action) => {
      state.consultSafeWatchAlert = {
        error: action.payload,
      }
    },

    clearConsultSafeWatchAlert: (state) => {
      state.consultSafeWatchAlert = {}
    },

    // Consult Alert Number

    setConsultAlertNumberLoading: (state) => {
      state.consultAlertNumber = {
        isLoading: true,
      };
    },

    setConsultAlertNumberSuccess: (state, action) => {
      state.consultAlertNumber = {
        data: action.payload
      };
    },

    setConsultAlertNumberFailure: (state, action) => {
      state.consultAlertNumber = {
        error: action.payload,
      }
    },

    // Consult Spouse on Lists

    setConsultSpouseOnListsLoading: (state) => {
      state.consultSpouseOnLists = {
        isLoading: true,
      };
    },

    setConsultSpouseOnListsSuccess: (state, action) => {
      state.consultSpouseOnLists = {
        data: action.payload
      };
    },

    setConsultSpouseOnListsFailure: (state, action) => {
      state.consultSpouseOnLists = {
        error: action.payload,
      }
    },

    clearConsultSpouseOnLists: (state) => {
      state.consultSpouseOnLists = {}
    },

    // Consult Representative on Lists

    setConsultRepresentativeOnListsLoading: (state) => {
      state.consultRepresentativeOnLists = {
        isLoading: true,
      };
    },

    setConsultRepresentativeOnListsSuccess: (state, action) => {
      state.consultRepresentativeOnLists = {
        data: action.payload
      };
    },

    setConsultRepresentativeOnListsFailure: (state, action) => {
      state.consultRepresentativeOnLists = {
        error: action.payload,
      }
    },

    clearConsultRepresentativeOnLists: (state) => {
      state.consultRepresentativeOnLists = {}
    },

    // Insert Client On List For Review

    setInsertClientOnListForReviewLoading: (state) => {
      state.insertClientOnListForReview = {
        isLoading: true,
      };
    },

    setInsertClientOnListForReviewSuccess: (state, action) => {
      state.insertClientOnListForReview = {
        data: action.payload
      };
    },

    setInsertClientOnListForReviewFailure: (state, action) => {
      state.insertClientOnListForReview = {
        error: action.payload,
      }
    },

    clearInsertClientOnListForReview: (state) => {
      state.insertClientOnListForReview = {}
    },

  },
})

export const {
  setConsultInternalListsLoading, setConsultInternalListsSuccess, setConsultInternalListsFailure, clearConsultInternalLists,
  setConsultInternationalListsLoading, setConsultInternationalListsSuccess, setConsultInternationalListsFailure, clearConsultInternationalLists,
  setConsultSafeWatchAlertLoading, setConsultSafeWatchAlertSuccess, setConsultSafeWatchAlertFailure, clearConsultSafeWatchAlert,
  setConsultAlertNumberLoading, setConsultAlertNumberSuccess, setConsultAlertNumberFailure,
  setConsultSpouseOnListsLoading, setConsultSpouseOnListsSuccess, setConsultSpouseOnListsFailure, clearConsultSpouseOnLists,
  setConsultRepresentativeOnListsLoading, setConsultRepresentativeOnListsSuccess, setConsultRepresentativeOnListsFailure, clearConsultRepresentativeOnLists,
  setInsertClientOnListForReviewLoading, setInsertClientOnListForReviewSuccess, setInsertClientOnListForReviewFailure, clearInsertClientOnListForReview,
} = listsSlice.actions

export default listsSlice.reducer;